interface QueueItem<T> {
    resolve: (data: T) => void;
    reject: (error: Error) => void;
}

type QueueType<T> = Array<QueueItem<T>>;

export class Bouncer<T> {
    protected running: boolean = false;
    protected queue: QueueType<T> = [];

    constructor(protected action: () => Promise<T>, protected runWithoutRequest: boolean = false) {
    }

    public getQueueLength(): number {
        return this.queue.length;
    }

    public request = (): Promise<T> => {
        return new Promise((resolve: (data: T) => void, reject: (error: Error) => void) => {
            this.queue.push({
                resolve: resolve,
                reject: reject
            });
        });
    };

    public run = (): Promise<T | null> => {
        if (!this.queue.length && !this.runWithoutRequest) {
            return Promise.resolve<T | null> (null);
        }

        if (this.running) {
            return this.request();
        }

        const tmpQueue: QueueType<T> = this.queue.slice();
        this.queue.length = 0;
        this.running = true;

        return this.action().then((data: T): T => {
            while (tmpQueue.length) {
                const queueItem: QueueItem<T> | undefined = tmpQueue.pop();
                if (queueItem != null) {
                    queueItem.resolve(data);
                }
            }

            this.running = false;

            return data;
        }).catch((error: any): Promise<T> => {
            while (tmpQueue.length) {
                const queueItem: QueueItem<T> | undefined = tmpQueue.pop();
                if (queueItem != null) {
                    queueItem.reject(error);
                }
            }

            this.running = false;

            return Promise.reject<T>(error);
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/Bouncer.ts